var ADD_RNA_ANALYSIS = 'Add RNA analysis';
var ADD_RNA_ANALYSIS_TO_REFLEX = 'Add RNA analysis to reflex';

export { ADD_RNA_ANALYSIS, ADD_RNA_ANALYSIS_TO_REFLEX };
//# sourceMappingURL=rna.esm.js.map
